/**
 *
 * @author Matthew Rawson @ 14/02/2018 13:48
 * @description
 * @notes
 *
 * The terminology of schedule and surveys is all over the place from a design point of view. The code is a reflection
 * of the data structure coming from the API.
 *
 * For the user, they use the word survey(s) for the schedule (only one) and the collection of surveys that the
 * schedule produces.
 *
 */
import React from "react"
import PropTypes from "prop-types"
import {Grid} from "react-bootstrap"
import {Route} from "react-router-dom"

import {PartialRoute, IndexRedirect} from "@irati/utils/history/routing"
import {HasPermissionTo} from "@irati/utils/permissions"

import {ScheduleSettings, QuestionLibrary} from "../pages"
import {ScheduleEdit} from "../../components/Schedule"

import sitemap from "../sitemap"

const ScheduleSettingsRoutes = ({match}) => {
  return (
    <Route
      path={match.path}
      render={() => (
        <HasPermissionTo permissions="insights.survey">
          <Grid>
            <ScheduleEdit match={match}>
              <PartialRoute match={match.path} {...sitemap.scheduleSettings} component={ScheduleSettings} />
              <PartialRoute match={match.path} {...sitemap.questionLibrary} component={QuestionLibrary} />
              <IndexRedirect match={match} to={sitemap.scheduleSettings.path} />
            </ScheduleEdit>
          </Grid>
        </HasPermissionTo>
      )} />
  )
}

ScheduleSettingsRoutes.propTypes = {
  match: PropTypes.object.isRequired
}
ScheduleSettingsRoutes.defaultProps = {}

export default ScheduleSettingsRoutes
